<template>
  <div class="el-modals" :style="{zIndex: zi}">
    <export-video :visible="TopnavMsg.isShowExportDialog" @closeDialog="closeExportVideo()" />
    <cover-cropper
      :visible="TopnavMsg.isShowCoverDialog"
      :coverType="'video'"
      @closeDialog="closeCoverCropper()"
    ></cover-cropper>

    <cover-cropper
      :visible="TopnavMsg.isShowSceneCoverDialog"
      :coverType="'scene'"
      @closeDialog="closeSceneCoverCropper()"
    ></cover-cropper>

    <saving-mask
      :visible="TopnavMsg.isShowSavingMask"
      :text="TopnavMsg.savingMaskText"
      @closeDialog="closeSavingMask()"
    ></saving-mask>

    <ppt-mask :visible="TopnavMsg.isShowPptMask" @closeDialog="closePptMask()"></ppt-mask>

    <generate-voice :visible="SoundRecord.isShowGenerateVoice" @closeDialog="closeGenerateVoice()"></generate-voice>
    <set-record-name :visible="SoundRecord.isShowSetRecordName" @closeDialog="closeSetRecordName()"></set-record-name>

    <logout-mask :visible="TopnavMsg.isShowLogoutMask" @closeDialog="closeLogoutMask()"></logout-mask>

    <record-error-tip></record-error-tip>
    <select-record></select-record>
    <save-record></save-record>
    <leave-record></leave-record>

    <record-add-to></record-add-to>

    <!-- video sprite -->
    <video-sprite-setting></video-sprite-setting>
    <video-sprite-cutting></video-sprite-cutting>
    <confirm-add-video></confirm-add-video>

    <!-- AI voice -->
    <place-smart-voice></place-smart-voice>

    <!-- <word-cloud
      :visible="TopnavMsg.isShowWordCloudDialog"
    ></word-cloud>-->

    <!-- 画布比例切换提示弹窗 -->
    <editor-resize></editor-resize>
    <!-- <export-scene-list></export-scene-list> -->
    <export-scene-list
      :visible="TopnavMsg.isShowExportSceneList"
      @closeDialog="closeExportSceneList()"
    ></export-scene-list>

    <open-template></open-template>
    <multiDraftMsg></multiDraftMsg>
    <MessageDialog></MessageDialog>
    <toAppTemplateRemind></toAppTemplateRemind>

    <versionRemove></versionRemove>
    <versionRevert></versionRevert>

    <commitReviewConfirm></commitReviewConfirm>
    <commitReviewRisk></commitReviewRisk>
    <commitReviewPass></commitReviewPass>

    <timelineTutorial></timelineTutorial>

    <vipTrialModal></vipTrialModal>
    <censoredInfo></censoredInfo>
    <presentationGuide></presentationGuide>
    <presentationLink></presentationLink>

    <IPRoleExport></IPRoleExport>
    <IPRolePayTip></IPRolePayTip>
    <IPRolePayModal v-if="iframeShown"></IPRolePayModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ExportVideo from "./topnav/exportDialog.vue"; // 导出视频
import CoverCropper from "./topnav/coverDialog.vue"; // 封面截取
import SavingMask from "./topnav/savingMask.vue"; // 保存项目时的遮罩层
import LogoutMask from "./topnav/logoutMask.vue"; // 退出登录时的遮罩层
import GenerateVoice from "./emodal/generateVoice.vue"; // 合成语音
import SetRecordName from "./emodal/setUploadRecordName.vue"; // 录音命名
import RecordAddTo from "./emodal/recordAddTo"; // 确认录音添加到全局还是单页的弹窗
import RecordErrorTip from "./emodal/record/errorTip";
import selectRecord from "./emodal/record/selectRecord";
import saveRecord from "./emodal/record/saveRecord";
import leaveRecord from "./emodal/record/leaveRecord";
import videoSpriteSetting from "./emodal/videoSprite/setting"; // 控制视频素材的全局预览
import videoSpriteCutting from "./emodal/videoSprite/cutVideo"; // 视频素材剪辑弹窗
import confirmAddVideo from "./emodal/confirmAddVideo";
import placeSmartVoice from "./emodal/generateVoice/placeSmartVoice";
import pptMask from "./scenes/pptMask.vue";
import wordCloud from "./emodal/wordCloud/wordCloudDialog.vue";
import editorResize from "./emodal/editorResize.vue";
import exportSceneList from "./topnav/exportDialog/exportSceneList.vue";
import openTemplate from "./emodal/openTemplate.vue";
import multiDraftMsg from "./emodal/multiDraftMsg.vue";
import toAppTemplateRemind from "./topnav/toAppTemplateRemind.vue";
import MessageDialog from "./emodal/MessageDialog.vue";
import versionRemove from "./emodal/versionRemove.vue";
import versionRevert from "./emodal/versionRevert.vue";
import commitReviewConfirm from "./emodal/commitReviewConfirm";
import commitReviewRisk from "./emodal/commitReviewRisk";
import commitReviewPass from "./emodal/commitReviewPass";
import timelineTutorial from './emodal/timelineTutorial.vue';
import vipTrialModal from './emodal/vipTrialMessage/vipTrialModal.vue';
import censoredInfo from './emodal/censoredInfo/censoredInfo.vue';
import presentationGuide from './emodal/presentation/presentationGuide.vue';
import presentationLink from './emodal/presentation/presentationLink.vue';
import IPRoleExport from "./emodal/IPRolePay/IPRoleExport.vue";
import IPRolePayTip from "./emodal/IPRolePay/IPRolePayTip.vue";
import IPRolePayModal from "./emodal/IPRolePay/IPRolePayModal.vue";

export default {
  components: {
    ExportVideo,
    CoverCropper,
    SavingMask,
    LogoutMask,
    GenerateVoice,
    SetRecordName,
    RecordAddTo,
    RecordErrorTip,
    selectRecord,
    saveRecord,
    leaveRecord,
    videoSpriteSetting,
    videoSpriteCutting,
    confirmAddVideo,
    placeSmartVoice,
    pptMask,
    wordCloud,
    editorResize,
    exportSceneList,
    openTemplate,
    multiDraftMsg,
    toAppTemplateRemind,
    MessageDialog,
    versionRemove,
    versionRevert,
    commitReviewConfirm,
    commitReviewRisk,
    commitReviewPass,
    timelineTutorial,
    vipTrialModal,
    censoredInfo,
    presentationGuide,
    presentationLink,
    IPRoleExport,
    IPRolePayTip,
    IPRolePayModal
  },
  data() {
    return {
      zi: ""
    };
  },
  created() {
    // this.$bus.on("collectPersonal_vue", ({ data } = {}) => {
    //   if (data === "audio") {
    //     this.$modal.show("modalRecordAddTo");
    //   }
    // });
  },
  computed: {
    ...mapGetters(["TopnavMsg", "SoundRecord", "iframeShown"])
  },
  watch: {
    "TopnavMsg.isShowExportDialog"(val) {
      if (val) {
        this.zi = 29;
      } else {
        this.zi = "";
      }
    }
  },
  methods: {
    closeExportVideo() {
      this.$store.commit("save_TopnavMsg", {
        isShowExportDialog: false
      });
    },
    closeCoverCropper() {
      this.$store.commit("save_TopnavMsg", {
        isShowCoverDialog: false
      });
    },
    closeSceneCoverCropper() {
      this.$store.commit("save_TopnavMsg", {
        isShowSceneCoverDialog: false
      });
    },
    closeSavingMask() {
      this.$store.commit("save_TopnavMsg", {
        isShowSavingMask: false
      });
    },
    closePptMask() {
      this.$store.commit("save_TopnavMsg", {
        isShowPptMask: false
      });
    },
    closeLogoutMask() {
      this.$store.commit("save_TopnavMsg", {
        isShowLogoutMask: false
      });
    },
    closeGenerateVoice() {
      if (!this.SoundRecord.isShowGenerateVoice) {
        return;
      }
      this.$store.commit("save_SoundRecord", {
        isShowGenerateVoice: false
      });
    },
    closeSetRecordName() {
      this.$store.commit("save_SoundRecord", {
        isShowSetRecordName: false
      });
    },
    closeExportSceneList() {
      this.$store.commit("save_TopnavMsg", {
        isShowExportSceneList: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-modals {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 30;
}
</style>



// WEBPACK FOOTER //
// src/components/EModals.vue